module.exports = __webpack_public_path__ + "img/IMG_7189_L_Wood_MockedUp.e20ca9a9.jpg";